export const marketplaces: Record<string, string> = {
  GB: 'www.amazon.co.uk',
  US: 'www.amazon.com',
  CA: 'www.amazon.ca',
  AU: 'www.amazon.com.au',
  DE: 'www.amazon.de',
  FR: 'www.amazon.fr',
  IT: 'www.amazon.it',
  ES: 'www.amazon.es',
  NL: 'www.amazon.nl',
  BE: 'www.amazon.com.be',
  IE: 'www.amazon.ie',
  SE: 'www.amazon.se',
  PL: 'www.amazon.pl',
};
export function amazonSearch(country: string, brand: string, name: string, concentration: string) {
  const host = marketplaces[country];
  if (!host || !brand.trim() || !name.trim()) return null;
  const url = new URL('https://' + host + '/s');
  url.searchParams.set('k', [brand, name, concentration].filter(Boolean).join(' '));
  return url.href;
}
